import { render, staticRenderFns } from "./BoostPlanManagement.vue?vue&type=template&id=713f1172"
import script from "./BoostPlanManagement.vue?vue&type=script&lang=js"
export * from "./BoostPlanManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports